// src/analytics.js
import ReactGA from "react-ga4";

const measurementId = process.env.REACT_APP_MEASUREMENT_ID || ""; // Replace with your GA4 ID

export const initGA = () => {
  measurementId && ReactGA.initialize(measurementId);
};

export const logPageView = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
